export const mutationType = {
  GET_LISTS: 'GET_LISTS',
  GET_BY_ID: 'GET_BY_ID',
  UPDATE: 'UPDATE',
}
